const PAYMENT_STATUS = {
	pending: 'PENDING',
	completed: 'COMPLETED',
	refunded: 'REFUNDED',
};

export default PAYMENT_STATUS;